@if (
  accountNotificationsItems | translateMenuItems | async;
  as accountNotificationsItems
) {
  <p-button
    *transloco="let t; scope: 'uiComponents'"
    [attr.aria-label]="t('uiComponents.accountNotifications.buttonInfo')"
    styleClass="bd-toolbar-button {{
      isFirstToolbarItem ? 'bd-round-left' : ''
    }}"
    data-id="account-notifications"
    (onClick)="accountNotificationsMenu.toggle($event)"
    [text]="true"
    [pTooltip]="t('uiComponents.accountNotifications.buttonInfo')"
    tooltipPosition="bottom"
  >
    <div class="p-overlay-badge">
      <i class="ui-notification" data-id="notifications-icon"></i>
      <p-badge
        data-id="notifications-badge"
        [badgeDisabled]="noNotifications"
      ></p-badge>
    </div>
  </p-button>

  <p-menu
    #accountNotificationsMenu
    data-id="account-notifications-menu"
    styleClass="bd-toolbar-menu"
    [model]="accountNotificationsItems"
    [popup]="true"
    appendTo="body"
  >
    <ng-template #item let-item>
      @if (noNotifications) {
        <div class="py-20 text-center" data-id="no-notifications-menu">
          <div [class]="item.icon"></div>
          <div class="pt-2">{{ item.label }}</div>
        </div>
      } @else {
        <a
          class="p-menu-item-link flex justify-between items-center p-4"
          [attr.data-id]="'notification-' + item.label"
        >
          {{ item.label }}
        </a>
      }
    </ng-template>
  </p-menu>
}
